module.exports = __webpack_public_path__ + "assets/top-cities-salespeople.171dabb2.png";